export const IMPERSONATION_READ_ONLY_MESSAGE =
	"Read only while impersonating. Click the lock in the amber bar to allow writes."

export interface ImpersonationSessionFields {
	impersonatingFromUserId?: string | null
	impersonationWritesAllowed?: boolean | null
}

export function isImpersonationReadOnly(
	session: ImpersonationSessionFields | null | undefined,
) {
	return (
		!!session?.impersonatingFromUserId &&
		session.impersonationWritesAllowed !== true
	)
}

// Mutations that only read, or only move the admin in and out of the session.
export const READ_ONLY_ALLOWED_MUTATIONS: ReadonlySet<string> = new Set([
	"auth.getZeroToken",
	"auth.changeWorkspace",
	"auth.logout",
	"user.impersonateUser",
	"user.stopImpersonation",
	"user.setImpersonationWrites",
	"customData.listMcpTools",
	"customData.listSecureRefs",
	"linear.getCompletedIssuesForChangelog",
])

export function isMutationBlockedByImpersonation(
	session: ImpersonationSessionFields | null | undefined,
	path: string,
) {
	return (
		isImpersonationReadOnly(session) && !READ_ONLY_ALLOWED_MUTATIONS.has(path)
	)
}

// A same-origin path only, so the exit redirect can never leave the dashboard.
export function sanitizeReturnTo(value: string | null | undefined) {
	if (!value) return null
	if (!value.startsWith("/") || value.startsWith("//")) return null
	if (value.includes("\\")) return null
	return value.slice(0, 2048)
}
